import { createModel } from "@/orm/model";
import { belongsToIds, BelongsToIds, EntityRecord } from "@/orm/types";
import { Timestamp } from "firebase/firestore";
import { DealDirectoryRecord } from "./dealDirectory";
import { Note } from "./note";
import { getUserDefaultRecordId } from "./user";

export type DealRecord = EntityRecord & {
  establishedAt: Timestamp | null;
  companyName: string;
  location: string;
  listingLink: string;
  brokerage: string;
  broker: string;
  progressStatusTagIds: string[];
  ndaCompleted: boolean;
  cimCompleted: boolean;
  purchasePrice: number | null;
  revenue: number | null;
  cashFlow: number | null;
  pinnedFinancialDeckId: string | null;
  remarks: string;
  industry: string;
  notes: Note[] | null;
  includesRealEstate: boolean;
  belongsToDealDirectoryIds: BelongsToIds<DealDirectoryRecord>;
};

export const dealModel = createModel<DealRecord>({
  version: "1.0",
  collectionPath: "modelEntityRecordDeal",
  labels: {
    singular: "Deal",
    plural: "Deals",
  },
  getDefaultRecord: () => {
    return {
      establishedAt: null,
      companyName: "Untitled Deal " + new Date().toLocaleDateString(),
      location: "",
      listingLink: "",
      brokerage: "",
      broker: "",
      progressStatusTagIds: [],
      ndaCompleted: false,
      cimCompleted: false,
      purchasePrice: null,
      revenue: null,
      cashFlow: null,
      pinnedFinancialDeckId: null,
      remarks: "",
      industry: "",
      notes: null,
      includesRealEstate: false,
      belongsToDealDirectoryIds: belongsToIds([getUserDefaultRecordId()]),
    };
  },
});

export const getPathDealId = () => {
  return window.location.pathname.split("/deal/")[1].split("/")[0] || undefined;
};

export const getCurrentDealEntity = () => {
  const dealId = getPathDealId();

  if (!dealId) {
    throw new Error("No deal ID found in the path");
  }

  const record = dealModel.createEntityInstance({ id: dealId });
  return record;
};
